import React, { Fragment, useEffect } from "react";
import { Form, Button, InputNumber, Select, Input } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { fetchCategories } from "../../actions/category";
import { useDispatch, useSelector } from "react-redux";
// import JoditEditor from "jodit-react";

import "./SurveyScore.scss";
import { PAGE_SIZE } from "../../constants";
import { ReactSVG } from "react-svg";

const SurveyScoreForm = ({ handleSubmitForm, form, handleCancel }) => {
	const dispatch = useDispatch();
	const { categories } = useSelector((state) => state.fetchCategories);

	useEffect(() => {
		if (!categories) dispatch(fetchCategories({ start: 0, count: PAGE_SIZE }));
	}, [categories]);

	return (
		<div className="survey-score-form-container">
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Survey Category"
						name="survey_category_id"
						rules={[{ required: true, message: "Required" }]}
					>
						{categories && (
							<Select
								showSearch
								maxTagCount={"responsive"}
								placeholder="Survey Category"
								optionFilterProp="children"
								filterOption={(input, option) =>
									option.children.toLowerCase().indexOf(input.toLowerCase()) >=
									0
								}
							>
								{categories.data.data.map((category, index) => (
									<Select.Option key={index} value={category.id}>
										{category.name}
									</Select.Option>
								))}
							</Select>
						)}
					</Form.Item>
					<Form.Item
						label="Score Start"
						name="score_start"
						rules={[{ required: true, message: "Required" }]}
					>
						<InputNumber />
					</Form.Item>
					<Form.Item
						label="Score End"
						name="score_end"
						rules={[{ required: true, message: "Required" }]}
					>
						<InputNumber />
					</Form.Item>
					<div className="products-list-form">
						<Form.List name="product_ids">
							{(fields, { add, remove }, { errors }) => (
								<Fragment>
									{fields.map((field, index) => (
										<Form.Item
											key={field.key}
											label={index === 0 ? "Products" : ""}
										>
											<Form.Item {...field}>
												<Input
													placeholder="Product"
													style={{ width: "100%" }}
												/>
											</Form.Item>
											{fields.length > 1 ? (
												<MinusCircleOutlined
													className="dynamic-delete-button"
													onClick={() => remove(field.name)}
												/>
											) : null}
										</Form.Item>
									))}
									<Form.Item>
										<Button
											type="dashed"
											onClick={() => add()}
											style={{ width: "100%" }}
											icon={<PlusOutlined />}
										>
											Add Product
										</Button>
										<Form.ErrorList errors={errors} />
									</Form.Item>
								</Fragment>
							)}
						</Form.List>
					</div>
					<Form.Item name="product_description" label="Product's Description">
						<Input.TextArea />
					</Form.Item>
					<Form.Item name="product_status" label="Status">
						<Input />
					</Form.Item>
					<Form.Item name="product_recommendation" label="Recommendation">
						<Input />
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn-primary">
						Update
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default SurveyScoreForm;
